import { ApiResponse, HTTPVerb } from '../Modules/Utils/API/Interfaces/IApi';
import { ApiManager } from '../Modules/Utils/API/ApiManager';

enum APIConstants {
    GetPersonalLimits = '/api/PersonalLimits/GetPersonalLimits/',
}

export interface IGetPersonalLimitsResponse {
    DisplayableLimits?: Array<unknown>;
    ErrorCode?: number;
    ErrorDescription?: string;
}

export default class PersonalLimitsApi {
    public static GetPersonalLimits = (): Promise<ApiResponse<IGetPersonalLimitsResponse>> => {
        return ApiManager.getAPIInstance().authenticatedRequest({
            url: APIConstants.GetPersonalLimits,
            method: HTTPVerb.GET,
        });
    };
}
